import { render } from "./TabRefunds.vue?vue&type=template&id=917c0ae4"
import script from "./TabRefunds.vue?vue&type=script&lang=js"
export * from "./TabRefunds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__